/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */
package systems.frictionless.impulse.browser.style

import org.jetbrains.compose.web.css.CSSStyleRuleBuilder
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.GenericStyleSheetBuilder
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.marginTop
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.overflowY
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.paddingLeft
import org.jetbrains.compose.web.css.paddingRight
import org.jetbrains.compose.web.css.paddingTop
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import systems.frictionless.impulse.browser.style.constants.AUTO
import systems.frictionless.impulse.browser.style.constants.UNSET
import systems.frictionless.impulse.browser.style.constants.grid12
import systems.frictionless.impulse.browser.style.constants.grid2
import systems.frictionless.impulse.browser.style.constants.grid3
import systems.frictionless.impulse.browser.style.constants.grid4
import systems.frictionless.impulse.browser.style.constants.grid6
import systems.frictionless.impulse.browser.style.support.Margin
import systems.frictionless.impulse.browser.style.support.TextAlign
import systems.frictionless.impulse.browser.style.support.left
import systems.frictionless.impulse.browser.style.support.marginHorizontal
import systems.frictionless.impulse.browser.style.support.position
import systems.frictionless.impulse.browser.style.support.textAlign
import systems.frictionless.impulse.browser.style.support.top
import systems.frictionless.impulse.browser.style.support.transform
import systems.frictionless.impulse.browser.style.support.width

@Suppress("LongMethod")
fun AppStyleSheet.mobilePhoneLandscape(styleSheetBuilder: GenericStyleSheetBuilder<CSSStyleRuleBuilder>) {
    styleSheetBuilder.apply {
        className(mainContainer) style {
            padding(0.px)
            overflowY(AUTO)
            width(100.percent)
            maxWidth(UNSET)
        }

        combine(className(mainContainer), className(insights)) style {
            paddingLeft(grid6)
            paddingRight(grid6)
        }

        combine(className(centeredOnScreen), className(ignoreCenteringOnMobileLandscape)) style {
            position(UNSET)
            top(UNSET)
            left(UNSET)
            transform(UNSET)
            textAlign(TextAlign.CENTER)
            marginHorizontal(Margin.AUTO)
        }

        className(intro) style {
            width(100.percent)
        }

        className(question) style {
            paddingTop(grid2)
        }

        className(insights) style {
            paddingTop(grid4)
        }

        className(singleChoiceContainer) style {
            display(DisplayStyle.Block)
        }

        className(progress) style {
            display(DisplayStyle.None)
        }

        className(questionText) style {
            marginTop(0.px)
            marginBottom(grid4)
        }

        className(questionTextArea) style {
            marginTop(0.px)
        }

        desc(className(questionTextArea), type(questionTextArea)) style {
            height(grid12)
        }

        className(questionMultiChoiceBox) style {
            marginTop(grid3)
            marginBottom(grid3)
        }

        className(centeredOnScreen) style {
            width(UNSET)
        }

        className(singleChoice) style {
            textAlign(TextAlign.START)
        }

        className(addHorizontalPaddingInMobileLandscape) style {
            paddingLeft(grid6)
            paddingRight(grid6)
        }
    }
}
